module.exports = __webpack_public_path__ + "img/5.c349b4e6.svg";